import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

const Navbar = ({ isAuthenticated, userRole, onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout();
    navigate('/');
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#111111]/95 backdrop-blur-sm border-b border-[#A6A6A6]/20">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <div className="relative">
              <span className="text-3xl font-bold tracking-wider">
                <span className="group-hover:text-white transition-colors !text-base text-[#A6A6A6]">GT</span>
                <span className="!text-base text-[#C00000]"> ENGINEERING</span>
              </span>
              <div className="h-0.5 bg-gradient-to-r from-[#C00000] to-transparent mt-1"></div>
            </div>
          </Link>

          {/* Navigation */}
          <div className="flex items-center space-x-4">
            {isAuthenticated ?
            <>
                <Link to={userRole === 'engineer' ? '/engineer/dashboard' : '/client/dashboard'}>
                  <Button variant="ghost" className="text-[#A6A6A6] hover:text-white hover:bg-[#A6A6A6]/10">
                    Dashboard
                  </Button>
                </Link>
                <Button
                onClick={handleLogout}
                variant="outline"
                className="border-[#C00000] text-[#C00000] hover:bg-[#C00000] hover:text-white transition-all">

                  Déconnexion
                </Button>
              </> :

            <>
                <Link to="/login">
                  <Button variant="ghost" className="inline-flex items-center justify-center whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 hover:text-white hover:bg-[#A6A6A6]/10 !font-medium !text-xs gap-2 px-4 py-2 rounded-md text-[#A6A6A6]">
                    Connexion
                  </Button>
                </Link>
                <Link to="/register">
                  <Button className="inline-flex items-center justify-center whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 hover:bg-[#C00000]/90 !font-semibold !text-xs gap-2 py-2 px-6 rounded-md shadow-lg shadow-[#C00000]/30 text-white bg-[#C00000]">
                    S'inscrire
                  </Button>
                </Link>
              </>
            }
          </div>
        </div>
      </div>
    </nav>);

};

export default Navbar;